import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import {Refresh as RefreshIcon} from '@mui/icons-material';

const ErrorContainer = styled('div')(() => ({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'white',
}));

const ErrorContent = styled('div')(() => ({
  maxWidth: '600px',
  padding: '40px',
  backgroundColor: 'white',
  textAlign: 'center',
}));

const ErrorTitle = styled('h1')(() => ({
  fontSize: '20px',
  fontFamily: 'Lato',
  fontStyle: 'normal',
  fontWeight: '700',
  color: '#16124C',
  lineHeight: 'normal',
  marginBottom: '24px',
}));

const ErrorMessage = styled('p')(() => ({
  fontSize: '14px',
  fontFamily: 'Lato',
  fontStyle: 'normal',
  fontWeight: '400',
  color: '#16124C',
  lineHeight: 'normal',
  marginBottom: '24px',
}));

const RefreshButton = styled(Button)(() => ({
  fontSize: '14px',
  backgroundColor: '#AC5CCC',
  fontFamily: 'Lato',
  width: '169px',
  height: '33px',
  borderRadius: '6px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '100%',
  textTransform: 'none',
  padding: '5px 20px',
  '&:hover': {
    backgroundColor: '#9A4AB8',
  },
}));

const CallToAction = styled('p')(() => ({
    fontSize: '10px',
    fontFamily: 'Lato',
    fontStyle: 'regular',
    fontWeight: '400',
    lineHeight: '100%',
    color: "#16124C",
    textDecoration: 'underline',

            }
));

const ErrorBoundaryComponent = ({ resetError }) => {
  return (
    <ErrorContainer role="alertdialog" aria-labelledby="error-title" aria-describedby="error-message">
      <ErrorContent>
        <ErrorTitle id="error-title">Something went wrong loading the application</ErrorTitle>
        <ErrorMessage id="error-message">
          Don't worry, your data is completely safe. This usually fixes itself
          with a quick refresh.
        </ErrorMessage>
        <RefreshButton
          variant="contained"
          onClick={resetError}
        >
        <RefreshIcon sx={{ mr: 1 }} />
          Refresh Page
        </RefreshButton>
        <CallToAction>Contact Support and mention the error so we can look into it.</CallToAction>
      </ErrorContent>
    </ErrorContainer>
  );
};

export default ErrorBoundaryComponent;
